import { useFormContext } from 'react-hook-form';

export const useDirtyFormState = () => {
    const formContext = useFormContext();

    return formContext.formState.isDirty;
};
